module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.2d8e6c7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-solid-900.eot
// module id = oprI
// module chunks = 13 14